
  import { defineComponent, ref, computed, watch, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'ads-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref<any>({
        status: '',
        phone: '965',
        isSpecial: '',
        isHighQuality: '',
        price: undefined,
        size: undefined,
        packageId: '',
        propertyTypeId: '',
        propertyCategoryId: '',
        areaId: '',
        adTypeId: '',
      });

      const propertyTypesCategories = ref<any>([]);
      const propertyTypes = ref<any>([]);
      const adType = ref(null);

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        // keep emitting the ref so parent code using values.value continues to work
        emit('type-selected', selectedItems);
      };

      const onReset = () => {
        selectedItems.value = {
          status: '',
          phone: '965',
          isSpecial: 0,
          isHighQuality: 0,
          isPaid: 0,
          price: undefined,
          size: undefined,
          packageId: '',
          propertyCategoryId: '',
          propertyTypeId: '',
          areaId: '',
          adTypeId: '',
        };
        emit('reset', selectedItems.value);
      };

      // Dependent dropdowns
      watch(
        () => selectedItems.value.adTypeId,
        async (newVal) => {
          propertyTypesCategories.value = [];
          selectedItems.value.propertyCategoryId = '';
          propertyTypes.value = [];
          selectedItems.value.propertyTypeId = '';

          if (newVal) {
            await store.dispatch(
              Actions.GET_ALL_PROPERTY_CATEGORIES_BY_AD_TYPE_ID,
              {
                adType: newVal,
              }
            );
            propertyTypesCategories.value =
              store.getters.propertyAllCategoryList;
          }
        }
      );

      watch(
        () => selectedItems.value.propertyCategoryId,
        async (newVal) => {
          propertyTypes.value = [];
          selectedItems.value.propertyTypeId = '';

          if (newVal) {
            await store.dispatch(Actions.GET_ALL_PROPERTY_TYPE, {
              type: 'ads',
              propertyTypesCategoryId: newVal,
            });
            propertyTypes.value = store.getters.propertyTypesAllList;
          }
        }
      );

      onMounted(async () => {
        await store.dispatch(Actions.GET_ADS_PACKAGES_LIST);
        await store.dispatch(Actions.GET_ALL_AREAS_LIST, { type: 'ads' });
        await store.dispatch(Actions.GET_ALL_AD_TYPES);

        // preload from existing filter in store (if any)
        const fillter = store.getters.getadsFiltter;
        if (
          fillter?.phoneNumber !== undefined &&
          fillter?.phoneNumber !== null &&
          fillter?.phoneNumber !== '' &&
          !isNaN(fillter.phoneNumber)
        ) {
          selectedItems.value.phone = String(fillter.phoneNumber);
        }
        if (fillter?.status !== '' && fillter?.status !== 'undefined') {
          selectedItems.value.status = fillter.status;
        }
        if (fillter?.isSpecial !== undefined && fillter?.isSpecial !== null) {
          selectedItems.value.isSpecial = fillter.isSpecial;
        }
        if (
          fillter?.isHighQuality !== undefined &&
          fillter?.isHighQuality !== null
        ) {
          selectedItems.value.isHighQuality = fillter.isHighQuality;
        }
        if (fillter?.isPaid !== undefined && fillter?.isPaid !== null) {
          selectedItems.value.isPaid = String(fillter.isPaid);
        }
        if (fillter?.price !== undefined)
          selectedItems.value.price = fillter.price;
        if (fillter?.size !== undefined)
          selectedItems.value.size = fillter.size;
        if (fillter?.propertyCategoryId)
          selectedItems.value.propertyCategoryId = fillter.propertyCategoryId;
        if (fillter?.propertyTypeId)
          selectedItems.value.propertyTypeId = fillter.propertyTypeId; // fixed typo
        if (fillter?.areaId) selectedItems.value.areaId = fillter.areaId;
        if (fillter?.adTypeId) selectedItems.value.adTypeId = fillter.adTypeId;
      });

      return {
        adTypes: computed(() => store.getters.adTypesAllList),
        adsPackages: computed(() => store.getters.adsPackagesList),
        propertyTypesCategories,
        propertyTypes,
        areas: computed(() => store.getters.allListAreas),
        onSubmit,
        onReset,
        translate,
        selectedItems,
        adType,
      };
    },
  });
